/*
Diese Funktion fragtg ab, ob wir auf der WEbseite "Produkt" sind, um lädt dann die Warenbestandanzeige für die Warenbestandanzeige
für das Produkt neu, wenn eine andere Variante über Swatches gewählt wird"
ACHTUNG NUR SWATCHES - KEIN DROPDOWN 
*/
$(document).ready(function () {
   if (window.location.href.indexOf("products") > -1) {
       if (document.querySelector('input', 'button')) {
           document.querySelectorAll('input', 'button').forEach((elem) => {
               elem.addEventListener("click", function (event) {
                   console.log("Click");
                   setTimeout(function () {
                       $('#reload').load(" #reload");
                   }, 200);
               });
           });
       }
   }
});

/*
Entfernt die pulsierende Anzeige auf Seiten die nicht die Produktdetailseite sind. Shopify hat hier ein seltsames Verhalten gezeigt.
Deshalb ist das ausgeblendet

$(document).ready(function () {
   if (window.location.href.indexOf("products") > -1) {
          document.querySelectorAll('.center-pulse').forEach((centerpulse) => {
                  console.log("centerpulse");
                   centerpulse.remove();
               });
   }
});
*/